import NoConnection from "@/modules/app/components/NoConnection";
// import ViewerToCameraBanner from "viewer/components/ViewerToCameraBanner";

export default function StatusBar() {
  return (
    <>
      <NoConnection style={{ mb: "24" }} />
      {/* <ViewerToCameraBanner /> */}
    </>
  );
}
